export const SITE_NAME = "PDFWorkSpace";
export const SITE_ORIGIN = "https://pdfwork.space";
export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/og-image.png`;
export const DEFAULT_OG_IMAGE_ALT =
  "PDFWorkSpace - privacy-first PDF tools that run in the browser";
export const DEFAULT_TWITTER_CARD = "summary_large_image";
export const DEFAULT_AUTHOR_NAME = "Rahil Vahora";

export const buildCanonicalUrl = (path = "/") => {
  if (!path || path === "/") {
    return `${SITE_ORIGIN}/`;
  }

  return new URL(path, `${SITE_ORIGIN}/`).toString();
};

export const buildSiteSearchUrl = (queryToken = "{search_term_string}") =>
  `${SITE_ORIGIN}/tools?q=${queryToken}`;
